import React from "react";
import Hero from "../../components/Hero/Hero";
import Testimonials from "../../components/Testimonials/Testimonials";
import Footer from "../../components/Footer/Footer";

const Home: React.FC = () => {
  return (
    <div className="App">
      <Hero />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default Home;
